import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('academic');

export class Sanction extends Api {
  constructor(http, config = {}) {
    super(http, url, 'sanction', config);
  }
}
